"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UploadBar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _ErrorOutlineRounded = _interopRequireDefault(require("@material-ui/icons/ErrorOutlineRounded"));
var _ProgressBar = require("../progress_bar/ProgressBar");
var _Button = require("../button/Button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/require-default-props */

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    width: 400,
    borderRadius: '8px 8px 0 0',
    position: 'fixed',
    bottom: '0',
    right: '64px',
    zIndex: 1000
  },
  expand: {
    transform: 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(0deg)'
  },
  secondaryButton: {
    color: theme.palette.text.secondary
  },
  primaryButton: {
    color: theme.palette.primary.main
  },
  wrappedButton: {
    justifyContent: 'flex-end',
    padding: '8px 13px 8px 24px',
    borderTop: '1px solid',
    borderTopColor: theme.palette.divider
  },
  topBar: {
    padding: '4px 12px 4px 24px',
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.divider
  },
  wrappedProgressBar: {
    flexDirection: 'column'
  },
  contentText: {
    padding: '8px 0 8px 0',
    color: theme.palette.text.secondary
  },
  content: {
    maxHeight: 255,
    overflow: 'auto',
    padding: '8px 24px 0 24px'
  },
  iconError: {
    color: theme.palette.error.light
  },
  errorSecondaryText: {
    color: theme.palette.text.secondary,
    position: 'relative',
    flexGrow: '1',
    flexShrink: '1',
    flexBasis: '0%',
    fontSize: '14px'
  },
  errorPrimaryText: {
    color: theme.palette.text.main
  },
  listItem: {
    padding: 0,
    width: 'auto'
  }
}));
const UploadBar = _ref => {
  let {
    errorsList,
    totalUploadFiles,
    progressFileUpload,
    handleCancelUpload,
    handleCloseUpload,
    reloadErrorsUpload,
    uploadMessage,
    uploadInProgressMessage,
    errorMessage
  } = _ref;
  const classes = useStyles();
  const [expanded, setExpanded] = (0, _react.useState)(true);
  const [progress, setProgress] = (0, _react.useState)(0);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  (0, _react.useEffect)(() => {
    const uploadEvolution = 100 * progressFileUpload / totalUploadFiles;
    setProgress(uploadEvolution);
  }, [progress, progressFileUpload, totalUploadFiles]);
  const errorsUpload = /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.content,
    variant: "scrollable"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.errorPrimaryText,
    variant: "body2"
  }, ' ', errorMessage.replace('{count}', errorsList.length)), /*#__PURE__*/_react.default.createElement(_core.List, null, errorsList.map(value => /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    className: classes.listItem
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.errorSecondaryText,
    variant: "body2"
  }, ' ', value, ' '), /*#__PURE__*/_react.default.createElement(_ErrorOutlineRounded.default, {
    className: classes.iconError
  })))));
  const progressUpload = /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.content
  }, progress < 100 ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.contentText,
    variant: "body2"
  }, uploadMessage) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentText
  }), /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    className: classes.wrappedProgressBar
  }, /*#__PURE__*/_react.default.createElement(_ProgressBar.ProgressBar, {
    color: "primary",
    value: progress,
    size: "full"
  }), progress === 100 ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.contentText,
    variant: "body2"
  }, "Upload finalizado com sucesso!") : /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.contentText,
    variant: "body2"
  }, uploadInProgressMessage || `Arquivo ${progressFileUpload} de ${totalUploadFiles}`)));
  const cancelButton = /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: classes.secondaryButton,
    color: "secondary",
    onClick: handleCancelUpload
  }, "CANCELAR");
  const closeButton = /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: classes.primaryButton,
    color: "primary",
    onClick: handleCloseUpload
  }, "FECHAR");
  const reloadButton = /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: classes.primaryButton,
    color: "primary",
    onClick: reloadErrorsUpload
  }, "RECARREGAR");
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    disableSpacing: true,
    className: classes.topBar
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, "Upload"), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: (0, _clsx.default)(classes.expand, {
      [classes.expandOpen]: expanded
    }),
    onClick: handleExpandClick,
    "aria-expanded": expanded,
    "aria-label": "show more"
  }, /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null))), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    in: expanded,
    timeout: "auto",
    unmountOnExit: true
  }, errorsList.length !== 0 && progress === 100 ? errorsUpload : progressUpload, /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    className: classes.wrappedButton
  }, progress < 100 ? cancelButton : null, errorsList.length !== 0 && progress === 100 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cancelButton, reloadButton) : null, errorsList.length === 0 && progress === 100 ? closeButton : null)));
};
exports.UploadBar = UploadBar;
UploadBar.propTypes = {
  /**
   * Quantidade de arquivos em que o upload já foi realizado
   */
  progressFileUpload: _propTypes.default.number.isRequired,
  /**
   * Quantidade total de arquivos para upload
   */
  totalUploadFiles: _propTypes.default.number.isRequired,
  /**
   *  Lista de erros do upload
   */
  errorsList: _propTypes.default.arrayOf(_propTypes.default.string.isRequired),
  /**
   *  Função que será executada quando o botão `Cancelar` for clicado
   */
  handleCancelUpload: _propTypes.default.func.isRequired,
  /**
   *  Função que será executada quando o botão `Fechar` for clicado
   */
  handleCloseUpload: _propTypes.default.func.isRequired,
  /**
   *  Função que será executada quando o botão `Recarregar` for clicado
   */
  reloadErrorsUpload: _propTypes.default.func.isRequired,
  /**
   *  Função para alterar o texto de upload
   */
  uploadMessage: _propTypes.default.string,
  /**
   *  Mensagem exibida quando o upload estiver em andamento (opcional)
   */
  uploadInProgressMessage: _propTypes.default.string,
  /**
  * 
  Mensagem personalizada para erros de upload
  */
  errorMessage: _propTypes.default.string
};
UploadBar.defaultProps = {
  errorsList: [],
  uploadMessage: 'Espere o upload finalizar para continuar',
  errorMessage: 'Arquivos tiveram problemas ao fazer o upload'
};
var _default = exports.default = UploadBar;